var u = Object.defineProperty;
var n = (t, r) => u(t, "name", { value: r, configurable: !0 });
import { k as d, i as c } from "./awt-0-lodash-nxYJI_oT.js";
function I() {
  return window.navigator.userAgent.indexOf("MSIE ") > 0 || !!/Trident.*rv:11\./.exec(navigator.userAgent);
}
n(I, "isIE");
const o = class o {
  /**
   *
   * @param name component caller name, ex: SummaryStat
   * @param prefix string to prepend to name, ex: DeepDiveHeader
   * NOTE: please do not call this constructor from outside this class! Use the createCachedInstance function
   */
  constructor(r, e) {
    this.formatDataTest = d, this.name = r, this.prefix = e, this.dataTest = this.prefix ? this.formatDataTest(`${this.prefix}-${this.name}`) : this.formatDataTest(this.name);
  }
  static createCachedInstance(r, e) {
    const s = r + e, a = o.cache[s];
    if (a)
      return a;
    const i = new o(r, e);
    return o.cache[s] = i, i;
  }
  /**
   * @param suffix
   * returns formatted dataTest with suffix appended
   */
  concat(r) {
    return this.formatDataTest(`${this.dataTest}-${r}`);
  }
  get matchExact() {
    return `[data-testid="${this.dataTest}"]`;
  }
  get matchName() {
    return `[data-testid*="${this.formatDataTest(this.name)}"]`;
  }
};
n(o, "DtService"), o.cache = {};
let h = o;
const E = /* @__PURE__ */ n((t) => typeof t == "object" && t !== null && "label" in t && "value" in t, "isReactSelectOptions");
var T = /* @__PURE__ */ ((t) => (t.BREAKDOWN_PREFIX = "breakdown.", t.CHARACTERISTICS_PREFIX = "characteristics.", t.LINKED_ENTITY_SELECTIONS_OVERRIDE_METADATA_PREFIX = "linkedEntitySelections.overrideMetadata.", t.METADATA_PREFIX = "metadata.", t.PERFORMANCE_EXPOST_PREFIX = "performanceExpost.", t.RETURNS_PREFIX = "returns.", t.RISK_PREFIX = "risk.", t.SCENARIOS_PREFIX = "scenarios.", t.SECURITY_PREFIX = "security.", t))(T || {});
const A = /* @__PURE__ */ n((t, r, e) => {
  const s = String(r);
  if (c(t) || c(s))
    return r;
  const a = `#${t}|${s}`, i = e(a);
  return a === i ? r : i;
}, "translateDynamicContent"), f = /* @__PURE__ */ n((t, r) => {
  if (typeof t != "string")
    return t;
  if (!t)
    return "";
  const e = t.startsWith("#") ? t : `#${t}`, s = r(e);
  return s !== e ? s : r(t);
}, "translateWithHashSymbol");
function p(t, r) {
  if (r) {
    const e = Math.pow(10, r);
    return Math.round(t * e) / e;
  }
  return Math.round(t * 1e9) / 1e9;
}
n(p, "roundFloatingPointError");
const F = /* @__PURE__ */ n((t) => typeof t == "number" ? t : 0, "safeNumber"), g = /* @__PURE__ */ n((t, r) => new Promise((e) => {
  if (t.querySelector(r)) {
    e(t.querySelector(r));
    return;
  }
  const s = new MutationObserver(() => {
    t.querySelector(r) && (e(t.querySelector(r)), s.disconnect());
  });
  s.observe(t, {
    childList: !0,
    subtree: !0
  });
}), "waitForElement"), w = /* @__PURE__ */ n((t, r) => new Promise((e) => {
  if (t.querySelectorAll(r).length > 0) {
    e(t.querySelectorAll(r));
    return;
  }
  const s = new MutationObserver(() => {
    t.querySelectorAll(r).length > 0 && (e(t.querySelectorAll(r)), s.disconnect());
  });
  s.observe(t, {
    childList: !0,
    subtree: !0
  });
}), "waitForElements");
export {
  h as DtService,
  T as DynamicLocalizationPrefixEnum,
  I as isIE,
  E as isReactSelectOptions,
  p as roundFloatingPointError,
  F as safeNumber,
  A as translateDynamicContent,
  f as translateWithHashSymbol,
  g as waitForElement,
  w as waitForElements
};
//# sourceMappingURL=aw-utils-core.es.js.map
